// extracted by mini-css-extract-plugin
export var footer = "style-module--footer--1bf2a";
export var footerMenu = "style-module--footerMenu--EwE7V";
export var labelColumn = "style-module--labelColumn--UiGAp";
export var social = "style-module--social--yhb4g";
export var socialsWrapper = "style-module--socialsWrapper--ufNR+";